import React from 'react';
import classNames from 'classnames';
import './PhoneBadge.css';
import { isPhoneStationPlayer } from '../../containers/StatPage/utils';

type Props = {
  hands: number | null | undefined;
  wtsd: number | null | undefined;
  className?: string;
};

const PhoneBadge = React.memo(({ hands, wtsd, className }: Props) => {
  if (!isPhoneStationPlayer(hands, wtsd)) {
    return null;
  }

  return (
    <span
      className={classNames('PhoneBadge', className)}
      title={`${hands} hands, WTSD ${wtsd}%`}
      aria-label={`Calling station — ${hands} hands, WTSD ${wtsd}%`}
    >
      <span className="PhoneBadge__Icon" aria-hidden="true">
        📞
      </span>
    </span>
  );
});

export default PhoneBadge;
